(function($) {
	
	const $block = $('.wp-block-metropolis-project-category-section .swiper');
	
	$block.each( function() {
		
		let $container = $(this);
	
		$container.find('.post-wrap').addClass('swiper-slide').ready(function () {
						
			const carousel = new Swiper($container[0], {
				
				slidesPerView: 'auto',
				spaceBetween: 16,
    			containerModifierClass: 'carousel-',
				navigation: {
					nextEl: '.controls .next',
					prevEl: '.controls .prev',
					disabledClass: 'disabled',
					hiddenClass: 'hidden',
				},
				
			});
			
		});
	
	});
	
})(jQuery);